import {
    getBookingList,
    getBooking,
    createBooking,
    cancelBooking,
    changeBooking,
    updateBooking,
    getBookingAlarmCount,
} from "../apis/api_booking.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, sort: 'bookingDt,DESC'},
    items: [],
    item: {},
    
    itemWrite: {
        userId:0,
        trimId:0,
        scId:0,
        type:'',
        choice: [],
        userMemo:'',
        bookingDt:'',
        userVehicle:'',
        userVehicleNum:'',
        
        brandId: 0,
        brandName: '',
        brandUrl: '',

        modelId: 0,
        modelName: '',
        modelUrl: '',
        
        trimName: '',

        scName: '',
        scUrl: '',
        scShopName: '',
        scDealerName: '',

        trim:{},
        sc:{},

        getLocation: false,

        lat: 37.54707,
        har: 127.05162,

        addr:"서울특별시 성동구 성수일로8길 5 (성수동2가)",
    }
};

const getters = {
};

const mutations = {
    SET_BOOKING_LIST(state, items){
        state.items = items;
    },

    SET_BOOKING(state, payload) {
        state.item = payload
    },

    CLEAR_BOOKING(state) {
        state.item = {
            choice: []
        };
    },

    CLEAR_BOOKING_WRITE(state) {
        state.itemWrite.userId = 0;
        
        state.itemWrite.type = '';
        state.itemWrite.choice = [];
        state.itemWrite.userMemo = '';
        state.itemWrite.bookingDt = '';
        state.itemWrite.userVehicle = '';
        state.itemWrite.userVehicleNum = '';


        state.itemWrite.brandId = 0;
        state.itemWrite.brandName = '';
        state.itemWrite.brandUrl = '';

        state.itemWrite.modelId = 0;
        state.itemWrite.modelName = '';
        state.itemWrite.modelUrl = '';

        // state.itemWrite.trim = {};
        state.itemWrite.trimId = 0;
        state.itemWrite.trimName = '';

        // state.itemWrite.sc = {};
        state.itemWrite.scId = 0;
        state.itemWrite.scName = '';
        state.itemWrite.scUrl = '';
        state.itemWrite.scShopName = '';
        state.itemWrite.scDealerName = '';
        
        state.itemWrite.lat = 0;
        state.itemWrite.har = 0;
        state.itemWrite.addr = '';
        state.itemWrite.getLocation = false;

        state.itemWrite.lat = 37.54707;
        state.itemWrite.har = 127.05162;
        state.itemWrite.addr = "서울특별시 성동구 성수일로8길 5 (성수동2가)";

    },

    SET_BOOKING_WRITE(state, booking) {
        state.itemWrite = booking;
    },
};

const actions = {

    async GET_BOOKING_LIST({ state }, params = {}) {
        let filters = { ...state.filters,...params };
        try {
            const response = await getBookingList(filters);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_BOOKING({ commit }, id) {
        try {
            const response = await getBooking(id);
            commit('SET_BOOKING', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async CREATE_BOOKING(context, booking) {
        try {
            const response = await createBooking(booking);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async CANCEL_BOOKING(context, id) {
        try {
            const response = await cancelBooking(id);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },
    async CHANGE_BOOKING(context, id) {
        try {
            const response = await changeBooking(id);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async UPDATE_BOOKING(context, booking) {
        try {
            const response = await updateBooking(booking);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_ALARM_COUNT() {
        try {
            const response = await getBookingAlarmCount();
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    }
};

export default {mutations, state, actions, getters};